export default __webpack_public_path__ + "static/media/social-media1-01.12ad936e.png";